import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutMovementOffers extends Layout {
    sourceCarrierInsCtrl: DataSource;
    sourceCarrierOffer: DataSource;
    sourceMovement: DataSource;
    tableOffers: Table;
}
